import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { LiteService } from '@core/services/lite.service';

@Component({
  selector: 'mfp-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SliderComponent),
      multi: true
    }
  ]
})
export class SliderComponent implements OnInit, ControlValueAccessor {
  readonly rightValueLabelMinWidthPixels = 100;

  @Input() id = '';
  @Input() name = '';
  @Input() min = 0;
  @Input() max = 100;

  @Input() label = '';
  @Input() showAdvice = false;

  @Input() showValue = true;
  @Input() valueAuxLabel = '';
  @Input() valueLabelSafetyPixels = 50;
  @Input() valueLabelPosition: 'bottom' | 'right' = 'bottom';

  @Input() disabled = false;
  @Input() required = false;
  @Input() readonly = false;
  @Input() loading = false;

  private innerValue = 50;

  get value(): number {
    return this.innerValue;
  }

  set value(value: number) {
    if (value !== this.innerValue) {
      this.innerValue = Math.min(Math.max(value, this.min), this.max);
      this.onChangeCallback(this.innerValue);
      this.onTouchCallback();
    }
  }

  get smoothMin(): number {
    return Math.floor(this.min);
  }

  get smoothMax(): number {
    return Math.ceil(this.max);
  }

  constructor(private liteService: LiteService) {}

  ngOnInit(): void {
    this.innerValue = Math.min(Math.max(this.innerValue, this.min), this.max);
  }

  getValuePercentage(): number {
    let percentage = ((this.innerValue - this.min) * 100) / (this.max - this.min);
    if (percentage > 0 && percentage < 1) percentage = 1;
    return percentage;
  }

  // ControlValueAccessor
  private onChangeCallback = (_: number) => {};
  private onTouchCallback = () => {};

  writeValue(value: number): void {
    this.value = value;
  }

  registerOnChange(fn: (_: number) => void): void {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouchCallback = fn;
  }

  setDisabledState(state: boolean): void {
    this.disabled = state;
  }

  changeCoverageInput(): void {
    this.liteService.coverageValueInsuredAmount.emit(true);
  }
}
